module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/bitcoin-sv-ddc172c1ac30a2b7.jpg"+" 1440w",
        images: [{path: __webpack_public_path__ + "assets/images/bitcoin-sv-ddc172c1ac30a2b7.jpg",width: 1440,height: 352}],
        src: __webpack_public_path__ + "assets/images/bitcoin-sv-ddc172c1ac30a2b7.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/bitcoin-sv-ddc172c1ac30a2b7.jpg"},
        
        width: 1440,
        height: 352
      }